export default "__VITE_ASSET__YnpibA2i__"